<template>
  <b-overlay :show="isLoading">
    <b-row v-if="defaultExamDetails && correctAnswersCount">
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">
            تحصیح آزمون {{ examDetails.lessonTitle }} برای
            {{ examDetails.studentFullName }}
          </h1>
          <p>
            تعداد سوال های آزمون:
            <strong>
              {{ examDetails.questions.length }}
            </strong>
          </p>
          <p>
            تعداد پاسخ های درست:
            <strong>
              {{ correctAnswersCount }}
            </strong>
          </p>
          <div
            class="set-result-container"
            v-if="defaultExamDetails.status == 2"
          >
            <b-row>
              <b-col
                cols="6"
                v-for="question in examDetails.questions"
                :key="question.questionId"
              >
                <b-card-actions
                  class="card-action-custom"
                  :actionCollapse="true"
                  :title="question.questionText"
                >
                  <p>
                    پاسخ صحیح:
                    <strong>
                      {{ question.correctAnswer }}
                    </strong>
                    ({{ question[question.correctAnswer] }})
                  </p>
                  <p
                    :class="
                      userAnswer(question) == question.correctAnswer
                        ? 'text-success'
                        : 'text-danger'
                    "
                  >
                    پاسخ زبان آموز:
                    <strong>
                      {{ userAnswer(question) }}
                    </strong>
                    ({{
                      correctFullAnswer(
                        question.questionId,
                        userAnswer(question)
                      )
                    }})
                  </p>
                </b-card-actions>
              </b-col>
            </b-row>
            <div>
              <p>
                زبان آموز تعداد
                <strong>
                  {{ correctAnswersCount }}
                </strong>
                سوال از
                <strong>
                  {{ examDetails.questions.length }}
                </strong>
                سوال را درست پاسخ داده است.
              </p>
              <b-form @submit.prevent>
                <b-form-group label="نتیجه آزمون" label-for="result">
                  <b-form-input
                    v-model="examDetails.result"
                    id="result"
                    trim
                    placeholder="نتیجه نهایی آزمون (از 100)"
                  />
                </b-form-group>
              </b-form>
            </div>
            <div class="w-100">
              <b-form-group label="وضعیت آزمون">
                <div
                  class="d-flex align-items-center w-100 mt-1"
                  style="gap: 1.5rem"
                >
                  <b-form-radio
                    v-model="examDetails.status"
                    name="status"
                    class="custom-control-primary"
                    value="3"
                  >
                    قبول شده
                  </b-form-radio>
                  <b-form-radio
                    v-model="examDetails.status"
                    name="status"
                    class="custom-control-primary"
                    value="4"
                  >
                    رد شده
                  </b-form-radio>
                </div>
              </b-form-group>
            </div>
            <div class="d-flex align-items-center justify-content-end pb-4">
              <b-button variant="primary" @click="updateExamDetails"
                >ثبت نتیجه آزمون
              </b-button>
            </div>
          </div>
          <div
            v-else-if="
              defaultExamDetails.status == 3 || defaultExamDetails.status == 4
            "
          >
            <div class="d-flex align-items-center">
              <p class="mb-0 mr-1">وضعیت آزمون:</p>
              <b-badge
                :variant="examStatusBadgeColors[defaultExamDetails.status]"
              >
                {{ examStatusEnums[defaultExamDetails.status] }}
              </b-badge>
            </div>
            <p class="mt-1">
              نمره نهایی:
              <strong>
                {{ defaultExamDetails.result }}
              </strong>
            </p>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { GetASingleExam, UpdateAnExam } from "@/libs/Api/Exam";
export default {
  async mounted() {
    await this.getAnExam();
    let correctAnswersCount = 0;
    await this.examDetails.questions.forEach((item) => {
      if (this.userAnswer(item) == item.correctAnswer) {
        correctAnswersCount++;
      }
    });
    this.correctAnswersCount = correctAnswersCount;
  },
  data() {
    return {
      isLoading: false,
      examDetails: null,
      defaultExamDetails: null,
      correctAnswersCount: null,
      examStatusEnums: {
        1: "در انتظار برگزاری",
        2: "در انتظار نتیجه",
        3: "قبول شده",
        4: "رد شده",
        5: "غیبت زبان آموز",
        6: "غیبت استاد",
      },
      examStatusBadgeColors: {
        1: "warning",
        2: "secondary",
        3: "success",
        4: "danger",
        5: "danger",
        6: "danger",
      },
    };
  },
  methods: {
    async updateExamDetails() {
      try {
        this.isLoading = true;
        let _this = this;
        _this.examDetails.status = parseInt(_this.examDetails.status);
        let updateAnExam = new UpdateAnExam(_this);
        updateAnExam.setRequestParamDataObj(_this.examDetails);
        await updateAnExam.fetch((response) => {
          if (response.isSuccess) {
            _this.examDetails = response.data.exam;
            _this.defaultExamDetails = JSON.parse(
              JSON.stringify(response.data.exam)
            );
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    userAnswer(question) {
      let userAnswer = this.examDetails.answers.find(
        (item) => item.questionId == question.questionId
      );
      if (userAnswer) {
        return userAnswer.fullAnswer;
      }
    },

    correctFullAnswer(questionId, correctAnswerName) {
      let userAnswer = this.examDetails.questions.find(
        (item) => item.questionId == questionId
      );
      if (userAnswer) {
        return userAnswer[correctAnswerName];
      }
    },
    async getAnExam() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleExam = new GetASingleExam(_this);
        getASingleExam.setRequestParam({
          id: _this.$route.params.id,
          isForStudent: false,
        });
        await getASingleExam.fetch((response) => {
          if (response.isSuccess) {
            _this.examDetails = response.data;
            _this.defaultExamDetails = JSON.parse(
              JSON.stringify(response.data)
            );
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BBadge,
    BOverlay,
    BFormRadio,
    BCardActions,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BBadge,
  BOverlay,
  BFormRadio,
} from "bootstrap-vue";
import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";
</script>
